import { Component, OnInit, Injectable, ViewChild } from '@angular/core';
//import * as moment from 'moment';
import { NgbCalendar, NgbDatepicker, NgbDate, NgbDatepickerConfig, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbAlertModule, NgbDatepickerModule, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
//import { JsonPipe } from '@angular/common';
import '@angular/localize/init'

@Injectable()
// export class CustomAdapter extends NgbDateParserFormatter {
//   readonly DT_FORMAT = 'MM/DD/YYYY';

//   parse(value: string): NgbDateStruct {
//       if (value) {
//           value = value.trim();
//           let mdt = moment(value, this.DT_FORMAT)
//       }
//       return null;
//   }
//   format(date: NgbDateStruct): string {
//       if (!date) return '';
//       let mdt = moment([date.year, date.month - 1, date.day]);
//       if (!mdt.isValid()) return '';
//       return mdt.format(this.DT_FORMAT);
//   }
// }
@Component({
  selector: 'app-custom-quote-dashboard',
  // standalone: true,
	// imports: [NgbDatepickerModule, NgbAlertModule, FormsModule, JsonPipe],
  templateUrl: './custom-quote-dashboard.component.html',
  styleUrls: ['./custom-quote-dashboard.component.css']
})
export class CustomQuoteDashboardComponent {

  model!: NgbDateStruct;

  searchObj:any = {};
  constructor(
    public NgbDatepickerModule : NgbDatepickerModule,
    public NgbAlertModule : NgbAlertModule,
    public FormsModule : FormsModule,
    //public JsonPipe : JsonPipe
  ){
    this.searchObj.searchBy = '';
  }


  searchByChange(){
    this.searchObj.searchByEmail = '';
    this.searchObj.searchByRequest = '';
  }

  clearSearch(){
    this.searchObj = {};
    this.searchObj.searchBy = '';
    this.searchObj.searchByEmail = '';
    this.searchObj.searchByRequest = '';
  }
}
